// import { useTranslation } from '@obvio/app'
import { Checkout } from '@obvio/template'

import { Cursor } from '../Cursor'

import type { ReactElement } from 'react'

export function CheckoutPage(): ReactElement {
  // const { t } = useTranslation()
  return (
    <>
      <Cursor kind="black" />
      <Checkout mail="mail" />
    </>
  )
}
